import React from 'react';
import { DashboardLayout } from '../layouts/dashboard-layout/DashboardLayout';
import { ERouterPath } from '../features/router/ERouterPath';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';
import { UserAccountRoleEnum } from '../api/types';
import { ApplicationState } from '../app/store';
import { ISessionAppState } from '../app/session/reducer';

export const Home = withRouter(({ history }): JSX.Element => {
  const { user } = useSelector<ApplicationState, ISessionAppState>(state => state.session);

  const isCaregiver = user && [UserAccountRoleEnum.caregiver, UserAccountRoleEnum.adminCaregiver].includes(user.accountRole);
  const isAdmin = user && [UserAccountRoleEnum.adminCaregiver, UserAccountRoleEnum.administration].includes(user.accountRole);

  if (isCaregiver) {
    history.replace(ERouterPath.personalDossiers);
  } else if (isAdmin) {
    history.replace(ERouterPath.allDossiers);
  } else {
    history.replace(ERouterPath.dossier);
  }
  return <DashboardLayout />;
});
